import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { getGlobalStyleSheets } from "../../global-styles";

import * as TagNames from "./nav-tabs.tagnames";

@customElement(TagNames.NavTabPane)
export class AtlNavTabPane extends LitElement {
  declare active?: boolean;
  declare tabLabel?: string;
  declare tabName?: string;
  declare paneClassName?: string;

  static styles = [...getGlobalStyleSheets()];

  static properties = {
    active: { attribute: "active", type: Boolean },
    tabLabel: { attribute: "tab-label", type: String },
    tabName: { attribute: "tab-name", type: String },
    paneClassName: { attribute: "pane-class-name", type: String },
  };

  protected override createRenderRoot() {
    return this;
  }

  override updated() {
    const classNames = ["tab-pane", "fade"];

    if (this.active) {
      classNames.push("active");
      classNames.push("show");
    } else {
      classNames.push("d-none");
    }

    if (this.paneClassName) {
      classNames.push(this.paneClassName);
    }

    this.classList.value = classNames.join(" ");
  }
}
